import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { twMerge } from 'tailwind-merge';
import { useNotifications } from '../hooks/use-notifications';
import UnreadIndicator from './unread-indicator';
import { useOpenNotificationMenuQuery } from '../hooks/use-open-notification-menu-query';
import { BellIcon } from '@systemeio/ui/icons';
import { useActualHeaderLayoutType } from 'shared/components/header';
import { NotificationsMenuContent } from './notifications-menu-content';
export interface NotificationMenuProps {
  className?: string;
}
const defaultFilter = {
  onlyUnRead: false
};
export const NotificationMenuMobile = t0 => {
  const $ = _c(40);
  const {
    className
  } = t0;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    pagination
  } = usePagination(true);
  let t1;
  if ($[0] !== pagination) {
    t1 = {
      shouldFetchNotifications: false,
      limit: 3,
      pagination,
      filter: defaultFilter
    };
    $[0] = pagination;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    notificationsMeta
  } = useNotifications(t1);
  const {
    isDesktop
  } = useActualHeaderLayoutType();
  const t2 = isDesktop === false;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      allowCheck: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    openThroughQuery,
    setOpenThroughQuery
  } = useOpenNotificationMenuQuery(t3);
  let t4;
  if ($[4] !== setOpenThroughQuery) {
    t4 = () => {
      setIsMenuOpen(false);
      setOpenThroughQuery(false);
    };
    $[4] = setOpenThroughQuery;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const closeMenu = t4;
  let t5;
  if ($[6] !== closeMenu || $[7] !== isMenuOpen) {
    t5 = () => {
      if (isMenuOpen) {
        closeMenu();
        return;
      }
      setIsMenuOpen(true);
    };
    $[6] = closeMenu;
    $[7] = isMenuOpen;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const toggleMenuState = t5;
  let t6;
  let t7;
  if ($[9] !== openThroughQuery) {
    t6 = () => {
      if (openThroughQuery) {
        setIsMenuOpen(true);
      }
    };
    t7 = [openThroughQuery];
    $[9] = openThroughQuery;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  const t8 = isMenuOpen && "fill-background-secondary stroke-background-secondary";
  let t9;
  if ($[12] !== t8) {
    t9 = twMerge("fill-text-secondary stroke-text-secondary hover:fill-background-secondary hover:stroke-background-secondary transition", t8);
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <BellIcon className={t9} />;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== notificationsMeta?.hasUnread) {
    t11 = notificationsMeta?.hasUnread && <UnreadIndicator className="absolute right-0 top-0 p-0" />;
    $[16] = notificationsMeta?.hasUnread;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <div className="text-background-secondary/90 relative w-5 text-sm font-bold">{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== toggleMenuState) {
    t13 = <button onClick={toggleMenuState} className="focus-visible:border-brand-primary flex h-full items-center justify-around gap-2.5 border-b-4 border-transparent focus:outline-hidden">{t12}</button>;
    $[21] = t12;
    $[22] = toggleMenuState;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="fixed inset-0 bg-black/30" aria-hidden="true" />;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== className) {
    t15 = twMerge("bg-background-secondary relative w-full transform text-left shadow-xl transition-all", className);
    $[25] = className;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <NotificationsMenuContent />;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t15) {
    t17 = <div className="fixed inset-0 z-10 overflow-y-auto"><div className="flex w-full pt-[69px]"><TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enterTo="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 translate-y-0 sm:scale-100" leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"><DialogPanel className={t15}>{t16}</DialogPanel></TransitionChild></div></div>;
    $[28] = t15;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== closeMenu || $[31] !== isMenuOpen || $[32] !== t17) {
    t18 = <Dialog open={isMenuOpen} onClose={closeMenu}>{t14}{t17}</Dialog>;
    $[30] = closeMenu;
    $[31] = isMenuOpen;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== isMenuOpen || $[35] !== t18) {
    t19 = <Transition show={isMenuOpen} as={Fragment}>{t18}</Transition>;
    $[34] = isMenuOpen;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t13 || $[38] !== t19) {
    t20 = <>{t13}{t19}</>;
    $[37] = t13;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  return t20;
};